jQuery(document).ready(function ($) {
  if (typeof wp !== 'undefined' && typeof wp.customize !== 'undefined') {
    // 1. Couleur du header normal
    wp.customize('drc_header_background', function (value) {
      value.bind(function (newVal) {
        if (newVal === '') {
          $('#Drc_nav_menu').css('background', '');
        } else {
          $('#Drc_nav_menu').css('background', newVal);
        }
      });
    });

    // 2. Couleur du header sticky
    wp.customize('drc_sticky_header_background', function (value) {
      value.bind(function (newVal) {
        if (newVal === '') {
          $('#Drc_nav_menu').css('background', '');
        } else {
          $('#Drc_nav_menu.sticky').css('background', newVal);
        }
      });
    });

    // 3. Prévisualisation en direct du changement de police
    wp.customize('drc_body_font', function (value) {
      value.bind(function (newVal) {
        // Charger dynamiquement la police Google Fonts
        let linkId = 'drc-font-preview-link';
        let link = document.getElementById(linkId);
        if (!link) {
          link = document.createElement('link');
          link.id = linkId;
          link.rel = 'stylesheet';
          document.head.appendChild(link);
        }
        link.href =
          'https://fonts.googleapis.com/css2?family=' +
          encodeURIComponent(newVal) +
          ':wght@400;700&display=swap';

        // Créer ou mettre à jour le <style> pour appliquer la police
        let head = document.head || document.getElementsByTagName('head')[0];
        let style =
          document.getElementById('drc-font-preview-style') ||
          document.createElement('style');
        style.id = 'drc-font-preview-style';

        style.innerHTML = `
          body, .container, .row, p, h1, h2, h3, h4, h5, h6, .site-title, .nav-link {
            font-family: '${newVal}', sans-serif !important;
          }
        `;
        head.appendChild(style);
      });
    });
  } else {
    console.error(
      "Erreur : l'objet wp.customize est introuvable. Le script de personnalisation ne peut pas s'exécuter."
    );
  }
});
